import { useMutation } from '@tanstack/react-query';

import { queryAudioQuestion } from 'api/users/queryAudioQuestion';

export const useAudioQuestionMutation = () => {
  return useMutation({
    mutationFn: (params) => queryAudioQuestion(params),
  });
};
